var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#2D995F",
    fillOpacity: 0.51
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.5 26C32.57 26 29.375 29.195 29.375 33.125C29.375 36.98 32.39 40.1 36.32 40.235C36.44 40.22 36.56 40.22 36.65 40.235C36.68 40.235 36.695 40.235 36.725 40.235C36.74 40.235 36.74 40.235 36.755 40.235C40.595 40.1 43.61 36.98 43.625 33.125C43.625 29.195 40.43 26 36.5 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.12 44.2251C39.935 41.4351 33.11 41.4351 28.895 44.2251C26.99 45.5001 25.94 47.2251 25.94 49.0701C25.94 50.9151 26.99 52.6251 28.88 53.8851C30.98 55.2951 33.74 56.0001 36.5 56.0001C39.26 56.0001 42.02 55.2951 44.12 53.8851C46.01 52.6101 47.06 50.9001 47.06 49.0401C47.045 47.1951 46.01 45.4851 44.12 44.2251Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.985 34.0099C53.225 36.9199 51.155 39.4699 48.29 39.8149C48.275 39.8149 48.275 39.8149 48.26 39.8149H48.215C48.125 39.8149 48.035 39.8149 47.96 39.8449C46.505 39.9199 45.17 39.4549 44.165 38.5999C45.71 37.2199 46.595 35.1499 46.415 32.8999C46.31 31.6849 45.89 30.5749 45.26 29.6299C45.83 29.3449 46.49 29.1649 47.165 29.1049C50.105 28.8499 52.73 31.0399 52.985 34.0099Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.985 47.8851C55.865 49.3401 54.935 50.6001 53.375 51.4551C51.875 52.2801 49.985 52.6701 48.11 52.6251C49.19 51.6501 49.82 50.4351 49.94 49.1451C50.09 47.2851 49.205 45.5001 47.435 44.0751C46.43 43.2801 45.26 42.6501 43.985 42.1851C47.3 41.2251 51.47 41.8701 54.035 43.9401C55.415 45.0501 56.12 46.4451 55.985 47.8851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse2);
export default __webpack_public_path__ + "static/media/Ellipse2.66e87ad58d4c75b41d7a8e895e08ccb5.svg";
export { ForwardRef as ReactComponent };